// 封装http请求
import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import util from '../utils/util'
import apis from './apis'
import store from '@/store'

const http = axios.create({
  baseURL: process.env.VUE_APP_COUPON_BASEURL,
  timeout: 15000,
})
http.interceptors.request.use(
  (config) => {
    // 请求头里面加入各种判断
    const excludes = [
      '/sd_set',
      '/pub',
      '/vodc/gift/free/send',
      '/vodc/order/refund',
      'https://sk.ktvsky.com/ktvinfo/add',
      '/vodc/mls/my_list/add',
      '/vodc/mls/my_list/update',
      '/vodc/mls/my_list/del',
      '/vodc/mls/my_list/songs/del',
      '/vodc/mls/my_list/songs/add',
      '/vodc/singgame/enter',
      '/vodc/singgame/withdraw',
      'https://m.ktvsky.com/vodc/ktv/message/receive',
      'https://m.ktvsky.com/vodc/ktv/message/my',
      '/vodc/mls/my_list/all/v2',
      '/vodc/mls/my_list/songs/update',
      '/vodc/diancan/log',
    ]
    if (
      config.method === 'post' && config.data && config.data.constructor !== FormData && !excludes.includes(config.url)
    ) {
      if (util.getUrlPrem('uploadImg', config.url) !== 'up') {
        config.data = qs.stringify(config.data)
      }
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    if (config.url.includes('/ktvinfo/add')) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    const includeApi = [
      // 显示loading的请求url
      '/vod/song/next',
      apis.bless_new_free_pay,
      apis.photo_new_free_pay,
      apis.photo_old_free_pay,
      '/vod/video/send',
    ]
    const arr = includeApi.filter((item) => config.url.includes(item))
    const showNormalLoading = !(
      util.skeletonCheckRoute(location.href, 'ajax') && !arr.length
    )
    if (
      config.url.includes(apis.orderSong) && !location.href.includes('song_words_play')
    ) {
      // 如果是点歌接口就显示点歌loading
      Vue.$fetchLoading.open('icon2')
    } else if (
      !util.getUrlPrem('close_loading', config.url) && showNormalLoading && !config.url.includes(apis.getMyList)
    ) {
      Vue.$loading.open()
    } else {
      const { url } = config
      config.url = url.split('?close_loading=true')[0]
    }
    if (store.state.isMinProgram) {
      config.baseURL = 'https://m.ktvsky.com'
    }
    return config
  },
  (error) => {
    // 拦截请求错误
    Vue.$toast(error.errmsg)
    Promise.reject(error)
  }
)

http.interceptors.response.use(
  (response) => {
    const res = response.data || {}
    if (!response.config.url.includes(apis.getMyList)) {
      Vue.$loading.close()
    }
    // Vue.$loading.close()
    if (response.config.url.includes(apis.orderSong)) {
      Vue.$fetchLoading.close()
    }
    // 90后过期设备优化（定向区域：甘肃、青海）：https://m2miovoqda.feishu.cn/wiki/EczCwS250i55Bak05aucn4cOnso
    if (res.errcode === 21004) {
      Vue.$sendLog({
        event_type: 'show',
        event_name: '弹窗展示',
        event_data: {
          name: '90后特定拦截弹窗'
        }
      });

      Vue.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20231108/other/8032e98d13a6e9aaf852f525565c3c59.png', '', {
        callback: () => {
          Vue.$sendLog({
            event_type: 'click',
            event_name: '点击我知道了',
            event_data: {
              desc: '90后特定拦截弹窗',
            },
          });
          Vue.$RaiseMessage.close();
        }
      });

      return;
    }

    // 21005指的是云端歌曲
    if ([200, 21001, 21002, 21003, 21005].includes(res.errcode)) {
      return res;
    }
    const urlArr = [
      '//kcms.ktvsky.com/song_feedback/add',
      '/vod/appmusic/add',
      '/c/lsk/sign_up',
      '/c/lsk/score/free',
      'https://qncweb-back1.ktvsky.com',
      'https://qncweb-back1.ktvsky.com',
      '/vod/vip/order/v2',
      '/vodc/vip/wxpay',
      '/recom/recom_song',
      '/pub',
      '/sd_set',
      '/vodc/gzh/match',
      '/vodc/baochang-jz/info',
      '/ktvinfo/add',
      'https://upload-z1.qiniup.com/',
      '/vodc/mls/my_list/songs/del',
      'https://lapi.ktvsky.com/ad/add_white_ip',
      '/vodc/electronicmusic/status',
      'vodc/baochang-jz/wxpay',
      '/cell/search',
      '/vodc/ai/commit',
      '/vodc/ai/query',
      '/vodc/ai/home',
      '/vodc/ai/gift/send',
      '/vodc/ai/gift/history',
      '/vodc/send/vip', // 添加presentVipStatus接口
      '/vodc/receive/vip', // 添加receiveVip接口
      '/vodc/aizz/photo/check', // 图片检查接口，返回res让前端自己处理错误提示
    ]
    for (let i = 0; i < urlArr.length; i++) {
      if (response.config.url.indexOf(urlArr[i]) >= 0) {
        return res
      }
    }
    if (res.code === 200) {
      return res
    }
    if (
      res.errcode === 10002 && (res.errmsg === 'room_id is null' || res.errmsg === 'room is null' || res.errmsg === '未绑定房台')
    ) {
      return res
    }
    if (res.errmsg === '未绑定房台') {
      return store.commit('SAVE_SHOW_SCODE_BOX', true);
    }
    // 根据不同错误码进行提示
    Vue.$toast(res.errmsg)
    // return Promise.reject(res.errmsg)
  },
  (error) => {
    Vue.$fetchLoading.close()
    Vue.$loading.close()
    if (axios.isCancel(error)) {
      // console.log('Rquest canceled', error.message) // 请求如果被取消，这里是返回取消的message
    } else {
      // 调用一个错误提醒dialog
      Vue.$toast(error.errmsg)
      return Promise.reject(error)
    }
  }
)

export default http
